import { render } from "./Toolbar.vue?vue&type=template&id=4af5016b&scoped=true"
import script from "./Toolbar.vue?vue&type=script&lang=ts"
export * from "./Toolbar.vue?vue&type=script&lang=ts"

import "./Toolbar.vue?vue&type=style&index=0&id=4af5016b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4af5016b"

export default script